// extracted by mini-css-extract-plugin
module.exports = {"Disconnected":"Disconnected_Disconnected__Ivpiq"};